import { style } from '@vanilla-extract/css';

export const recommendationContainer = style({
  width: '100%',
  height: 'auto',
  borderCollapse: 'collapse',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: '16px',
  paddingBottom: '16px',
});

export const recommendationInnerContainer = style({
  padding: '16px',
  background: 'var(--site-theme-background-color, #f9fafb)',
  borderRadius: 'var(--site-theme-border-radius, 5px)',
  border: '1px solid var(--site-theme-border-color, #d1d5db)',
});

export const imageContainer = style({
  marginBottom: '16px',
  marginRight: '16px',
  verticalAlign: 'top',
  width: '50px',
});

export const contentContainer = style({
  color: 'var(--site-theme-text-on-background-color, #282828)',
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  marginBottom: '16px',
});

export const button = style({
  filter: 'drop-shadow(0 1px 1px rgb(0 0 0 / 0.05))',
  cursor: 'pointer',
  background: 'var(--site-theme-background-color, #FFFFFF)',
  border: '1px solid var(--site-theme-border-color, #d1d5db)',
  borderRadius: 'var(--site-theme-border-radius, 4px)',
  color: 'var(--site-theme-text-on-background-color, #282828)',
  fontSize: '14px',
  fontWeight: '600',
  height: '40px',
  lineHeight: '21px',
  width: '100%',
});

export const subtitle = style({
  padding: '0',
  color: 'var(--site-theme-text-on-background-color, #767676)',
  opacity: 0.6,
  fontSize: '14px',
  fontWeight: '400',
  display: 'block',
});
